import { useMemo } from "react";
import {
    ComposableMap,
    Geographies,
    Geography,
    Marker,
} from "@vnedyalk0v/react19-simple-maps";
import { geoCentroid } from "d3-geo";

import geoUrl from "../../../../assets/world-countries.json";

function norm(s) {
    return String(s || "").toLowerCase().trim();
}

function normalizeCountryTitle(input) {
    const s = String(input || "").trim();
    const m = s.match(/\(([^)]+)\)/);
    if (m?.[1]) return m[1];
    if (s.includes(" - ")) return s.split(" - ")[0].trim();
    return s;
}

export default function WorldMap({ selectedName, marker }) {
    const selectedNorm = useMemo(
        () => norm(normalizeCountryTitle(selectedName)),
        [selectedName]
    );

    const forcedMarker =
        Array.isArray(marker) && marker.length === 2 ? marker : null;

    const W = 370;
    const H = 188;

    const SCALE = 60;
    const TX = W / 2 + 30;
    const TY = H / 2 + 14;

    const COLOR_SELECTED = "#7B76FF";

    return (
        <div style={{ width: "100%", aspectRatio: `${W} / ${H}` }}>
            <ComposableMap
                key={`map-${W}-${H}-${SCALE}-${TX}-${TY}`}
                width={W}
                height={H}
                projection="geoEquirectangular"
                projectionConfig={{
                    scale: SCALE,
                    translate: [TX, TY],
                }}
                style={{ width: "100%", height: "100%", display: "block" }}
            >

                <defs>
                    <pattern
                        id="dots"
                        patternUnits="userSpaceOnUse"
                        width="4"
                        height="4"
                    >
                        <rect width="4" height="4" fill="#ffffff" />
                        <circle
                            cx="2"
                            cy="2"
                            r="0.6"
                            fill="#7B76FF"
                        />
                    </pattern>
                </defs>

                <Geographies geography={geoUrl}>
                    {({ geographies }) => {
                        let centroid = null;

                        const countries = geographies
                            .filter((geo) => {
                                const name =
                                    geo.properties?.name ||
                                    geo.properties?.NAME ||
                                    geo.properties?.ADMIN ||
                                    "";
                                return norm(name) !== "antarctica";
                            })
                            .map((geo) => {
                                const name =
                                    geo.properties?.name ||
                                    geo.properties?.NAME ||
                                    geo.properties?.ADMIN ||
                                    "";

                                const isSelected = norm(name) === selectedNorm;

                                if (isSelected) {
                                    try {
                                        centroid = geoCentroid(geo);
                                    } catch {
                                        centroid = null;
                                    }
                                }

                                return (
                                    <Geography
                                        key={geo.rsmKey}
                                        geography={geo}
                                        style={{
                                            default: {
                                                fill: isSelected
                                                    ? "url(#dots)"
                                                    : "url(#dots)",

                                                stroke: "none",
                                                outline: "none",
                                            },
                                            hover: {
                                                fill: "url(#dots)",
                                                stroke: "none",
                                                outline: "none",
                                            },
                                            pressed: {
                                                fill: "#7B76FF",
                                                stroke: "none",
                                                outline: "none",
                                            }
                                        }}
                                    />
                                );
                            });

                        const markerCoords = forcedMarker || centroid;

                        return (
                            <>
                                {countries}

                                {markerCoords && (
                                    <Marker coordinates={markerCoords}>
                                        <svg width={24} height={24} viewBox="0 0 24 24" x={-12} y={-12}>

                                            <circle
                                                cx="12"
                                                cy="12"
                                                r="11"
                                                fill={COLOR_SELECTED}
                                            />

                                            <circle
                                                cx="12"
                                                cy="12"
                                                r="7"
                                                fill="#ffffff"
                                            />

                                            <circle
                                                cx="12"
                                                cy="12"
                                                r="4"
                                                fill={COLOR_SELECTED}
                                            />

                                        </svg>
                                    </Marker>
                                )}
                            </>
                        );
                    }}
                </Geographies>
            </ComposableMap>
        </div>
    );
}